import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    items: {},
    lastMutation: {
        type: 'init',
        altId: null,
        revision: 0,
    },
};

function nextMutation(state, type, altId = null) {
    state.lastMutation = {
        type,
        altId,
        revision: (state.lastMutation?.revision || 0) + 1,
    };
}

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        selectOption: {
            reducer(state, action) {
                const { altId, name, option, quantity, productImage } = action.payload;
                state.items[altId] = { name, option, quantity, productImage };
                nextMutation(state, 'upsert', altId);
            },
            prepare(altId, name, option, quantity, productImage = '') {
                return { payload: { altId, name, option, quantity, productImage } };
            },
        },
        clearOption: {
            reducer(state, action) {
                delete state.items[action.payload.altId];
                nextMutation(state, 'remove', action.payload.altId);
            },
            prepare(altId) {
                return { payload: { altId } };
            },
        },
        clearCart(state) {
            state.items = {};
            nextMutation(state, 'clear');
        },
        hydrateCart(state, action) {
            state.items = action.payload || {};
            nextMutation(state, 'hydrate');
        },
    },
});

export const { selectOption, clearOption, clearCart, hydrateCart } = cartSlice.actions;
export default cartSlice.reducer;
